import React from 'react';
export function FooterOferta() {
  return <footer className="border-t border-violet-line/60 bg-violet-deep" data-id="element-19" data-mp="1cs4wt4mggcel">
      <div className="mx-auto max-w-5xl px-6 py-12 text-center lg:px-8" data-id="element-20" data-mp="2vuf4d2zi2yic">
        <p className="font-serif text-xl text-bone" data-id="element-21" data-mp="39laeeilqjlni">
          Recupérate con Poder — Freddy Pimentel
        </p>
        <p className="mt-2 font-sans text-xs font-light uppercase tracking-[0.22em] text-bone/50" data-id="element-22" data-mp="34tsfs176px5p">
          Mentor y Coach de Relaciones de Pareja
        </p>
      </div>
    </footer>;
}